/**
 * Map optional DatasetMeta → §6.7 verdict (FR-A8 shell glue).
 * Extracted so field mapping is unit-testable without mounting the router.
 */
import type { DatasetMeta } from '@meridian/contracts';

import { FRESH, evaluateStaleness, type StalenessVerdict } from './evaluate-staleness';

/** Meta still loading or failed — never invent stale while chrome is unsettled. */
export function stalenessFromMeta(
  meta: DatasetMeta | undefined,
  now: Date = new Date(),
): StalenessVerdict {
  if (meta === undefined) return FRESH;
  return evaluateStaleness(
    {
      asOf: meta.asOf,
      lastIngestAt: meta.lastIngestAt,
      lastDataAdvancedOn: meta.lastDataAdvancedOn,
      lastOperationalTradingDay: meta.lastOperationalTradingDay,
      membershipAsOf: meta.membershipAsOf,
    },
    now,
  );
}
